import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '@/lib/api';
import { Button } from '@/components/ui/button';
import { ArrowLeft, ArrowUp, ArrowDown, Receipt, Wallet } from '@phosphor-icons/react';

export default function MRPartyLedgerPage() {
  const { customerId } = useParams();
  const navigate = useNavigate();
  const [ledger, setLedger] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (customerId) {
      api.getPartyLedger(customerId).then(r => { setLedger(r.data); setLoading(false); }).catch(() => setLoading(false));
    }
  }, [customerId]);

  if (loading) return <div className="p-4 text-center" style={{ color: '#8A94A6' }}>Loading ledger...</div>;
  if (!ledger) return <div className="p-4 text-center" style={{ color: '#FF3B30' }}>Ledger not found</div>;

  return (
    <div className="space-y-4">
      {/* Header */}
      <div className="px-4 pt-4">
        <button onClick={() => navigate(-1)} className="flex items-center gap-1 text-xs font-semibold mb-2" style={{ color: '#007AFF' }}>
          <ArrowLeft size={14} /> Back
        </button>
        <h2 className="text-lg font-extrabold tracking-tight" style={{ fontFamily: 'Manrope, sans-serif', color: '#0A2540' }}>
          {ledger.customer_name}
        </h2>
        <p className="text-[10px] font-medium" style={{ color: '#8A94A6' }}>Party Ledger</p>
      </div>

      {/* Balance Card */}
      <div className="mx-4 p-4 rounded-xl" style={{ background: '#0A2540' }}>
        <div className="grid grid-cols-3 gap-3">
          <div>
            <p className="text-[9px] font-bold uppercase" style={{ color: 'rgba(255,255,255,0.4)' }}>Debit</p>
            <p className="text-lg font-bold text-white mt-1" style={{ fontVariantNumeric: 'tabular-nums' }}>₹{ledger.total_debit.toLocaleString()}</p>
          </div>
          <div>
            <p className="text-[9px] font-bold uppercase" style={{ color: 'rgba(255,255,255,0.4)' }}>Credit</p>
            <p className="text-lg font-bold text-white mt-1" style={{ fontVariantNumeric: 'tabular-nums' }}>₹{ledger.total_credit.toLocaleString()}</p>
          </div>
          <div>
            <p className="text-[9px] font-bold uppercase" style={{ color: 'rgba(255,255,255,0.4)' }}>Balance</p>
            <p className="text-lg font-bold mt-1" style={{ color: ledger.balance >= 0 ? '#FF3B30' : '#34C759', fontVariantNumeric: 'tabular-nums' }}>
              ₹{Math.abs(ledger.balance).toLocaleString()}
            </p>
            <p className="text-[9px]" style={{ color: 'rgba(255,255,255,0.4)' }}>{ledger.balance >= 0 ? 'Due' : 'Advance'}</p>
          </div>
        </div>
      </div>

      {/* Transactions */}
      <div className="px-4 space-y-2 pb-4">
        <p className="text-[10px] font-bold uppercase tracking-widest" style={{ color: '#8A94A6' }}>Transactions ({ledger.entries.length})</p>
        {ledger.entries.length === 0 ? (
          <div className="p-8 text-center rounded-xl border" style={{ background: '#FFFFFF', borderColor: '#E2E4E9' }}>
            <Wallet size={40} weight="duotone" style={{ color: '#E2E4E9' }} className="mx-auto mb-2" />
            <p className="text-sm" style={{ color: '#8A94A6' }}>No transactions yet</p>
          </div>
        ) : ledger.entries.map((e, i) => (
          <div key={i} className="p-3 rounded-xl border flex items-center gap-3" style={{ background: '#FFFFFF', borderColor: '#E2E4E9' }}>
            <div className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0"
              style={{ background: e.type === 'sale' ? '#007AFF10' : e.debit > 0 ? '#FF3B3010' : '#34C75910' }}>
              {e.type === 'sale' ? <Receipt size={16} weight="duotone" style={{ color: '#007AFF' }} /> :
                e.debit > 0 ? <ArrowUp size={16} weight="bold" style={{ color: '#FF3B30' }} /> :
                <ArrowDown size={16} weight="bold" style={{ color: '#34C759' }} />
              }
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-bold truncate" style={{ color: '#0A2540' }}>{e.description}</p>
              <p className="text-[10px]" style={{ color: '#8A94A6' }}>{e.date} | {e.type}</p>
            </div>
            <div className="text-right shrink-0">
              {e.debit > 0 && <p className="text-xs font-bold" style={{ color: '#FF3B30', fontVariantNumeric: 'tabular-nums' }}>₹{e.debit.toLocaleString()}</p>}
              {e.credit > 0 && <p className="text-xs font-bold" style={{ color: '#34C759', fontVariantNumeric: 'tabular-nums' }}>₹{e.credit.toLocaleString()}</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
